/* oxlint-disable typescript/no-explicit-any */
import * as React from 'react';
import { wrapDisplayName } from '@cian/react-utils';

import { EReportStatus } from '../../constants/report';
import { useSelector } from 'react-redux';
import { getReportState } from '../../selectors/report';

export type TParams = { in: EReportStatus[] } | { notIn: EReportStatus[] };

/**
 * HOC скрывающий блоки, если статус отчета включен в белый список (in) или не включен в черный (notIn)
 */
export function withVisibleInReportStatus<P>(params: TParams) {
  return (Component: React.ComponentType<P>) => {
    const Wrapper: React.FC<P> = (props: P) => {
      const { reportStatus } = useSelector(getReportState);

      if ('in' in params) {
        return params.in.includes(reportStatus) ? <Component {...(props as any)} /> : null;
      }

      return params.notIn.includes(reportStatus) ? null : <Component {...(props as any)} />;
    };

    Wrapper.displayName = wrapDisplayName(Component as any, 'withVisibleInReportStatus');

    return Wrapper;
  };
}
